import { connect } from 'react-redux';
import View from './CoverageView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  hasSpouseSelector,
  principalNameSelector,
  spouseNameSelector,
  principalAdditionalCoverageSelector,
  spouseAdditionalCoverageSelector,
} from './CoverageSelector';
import { updateWhatIfsData } from '../../WhatIfsActions';
import {
  areOptionsLoaded,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  whatIfTypeSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  whatIfType: whatIfTypeSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  hasSpouse: hasSpouseSelector(state, ownProps),
  principalName: principalNameSelector(state, ownProps),
  spouseName: spouseNameSelector(state, ownProps),
  principalAdditionalCoverage: principalAdditionalCoverageSelector(state, ownProps),
  spouseAdditionalCoverage: spouseAdditionalCoverageSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
